export enum SistemaOrigemEnum {

  DAS_AINF = 6,
  DAS_DAU = 7,
  DAS_PARCELA_MINIMA = 9,
  DAS_MEI = 15,
  DAS_COBRANCA = 16
}
